/**
=========================================================
* Market Place React - v2.1.0
=========================================================

* Product Page: https://litech.site/product/material-dashboard-react
* Copyright 2022 Li-tech (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useEffect } from "react";
import GTranslateIcon from "@mui/icons-material/GTranslate";
// react-router components
import { Link, useNavigate } from "react-router-dom";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// Market Place React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

// Market Place React example components
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Market Place React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setLogout,
  setOpenConfigurator,
} from "context";
import { Breadcrumbs, TextField } from "@mui/material";
import getText from "Translator";
import { setLang } from "context";

function DashboardNavbar({ absolute, light, searchHandler, title, showserch }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentNavbar,
    fixedNavbar,
    openConfigurator,
    darkMode,
    lang,
  } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
    >
      {/* <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem
        icon={<Icon>podcasts</Icon>}
        title="Manage Podcast sessions"
      /> */}
      {/* <NotificationItem
        onClick={() => {
           setLang(dispatch, controller.lang == "fa" ? "en" : "fa");
        }}
        icon={<GTranslateIcon />}
        title={getText("lang", controller.lang)}
      /> */}
      <NotificationItem
        onClick={() => {
          setLogout(dispatch, !miniSidenav);
          navigate("/", { replace: true });
        }}
        icon={<ExitToAppIcon />}
        title={getText("exit", controller.lang)}
      />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  return (
    <AppBar
      position="fixed"
      color="primary"
      mb={5}
      style={{ direction: "ltr" }}
    >
      <Toolbar>
        <MDBox
          color="inherit"
          mb={{ md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini: true })}
        >
            <MDBox color={light ? "white" : "inherit"}>
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              onClick={handleOpenMenu}
            >
              <Icon fontSize="medium">account_circle</Icon>
            </IconButton>

            <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarMobileMenu}
              onClick={handleMiniSidenav}
            >
              <Icon fontSize="medium">
                {miniSidenav ? "menu_open" : "menu"}
              </Icon>
            </IconButton>
            {/*     <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarIconButton}
              onClick={handleConfiguratorOpen}
            >
              <Icon sx={iconsStyle}>settings</Icon>
            </IconButton>
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarIconButton}
              aria-controls="notification-menu"
              aria-haspopup="true"
              variant="contained"
              onClick={handleOpenMenu}
            >
              <Icon>notifications</Icon>
            </IconButton>*/}
            {renderMenu()}
          </MDBox>
         
          <div style={{ minWidth: "30%", paddingLeft: 15 }}>{title}</div>
          <MDBox pr={1} pl={2}>
            {showserch && (
              <TextField
                fullWidth
                style={{ color: "#FFF" }}
                onChange={(event) => {
                  searchHandler(event.target.value);
                }}
                placeholder={getText("search", lang)}
              />
            )}
          </MDBox>
          <IconButton
            size="small"
            disableRipple
            color="inherit"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowBackIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
